import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

export default class TextWithHighlights {
    constructor(container) {
        this.container = container;
        this.content = this.container.querySelector('.text-highlights__content');
        this.highligh_circles = this.container.querySelectorAll('.text-highlight--circle svg path');
        this.highligh_double_circles = this.container.querySelectorAll('.text-highlight--double-circle svg path');
        this.highligh_lines = this.container.querySelectorAll('.text-highlight--underline svg path');

        this.init();
    }

    init = () => {
        this.text_lines = new SplitText(this.content, { type: 'lines,words', linesClass: "" });
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.container,
                start: 'top bottom-=200px',
                // markers: true
            }
        })
        tl.fromTo(this.text_lines.words,
            {
                opacity: 0
            },
            {
                opacity: 1,
                duration: 0.6,
                stagger: { each: 0.02, ease: 'power.out', from: 'random' },
                ease: 'power3.out',
            });

        tl.fromTo(this.highligh_circles,
            {
                drawSVG: '0%',
            },
            {
                drawSVG: '0% 100%',
                duration: 0.6,
                stagger: { each: 0.02, ease: 'power.out', from: 'random' },
                ease: 'power3.inOut',
            }, '<1');

        tl.fromTo(this.highligh_double_circles,
            {
                drawSVG: '0%',
            },
            {
                drawSVG: '0% 100%',
                duration: 0.8,
                stagger: { each: 0.04, ease: 'power.out', from: 'random' },
                ease: 'power3.inOut',
            }, '<1');

        tl.fromTo(this.highligh_lines,
            {
                scaleX: 0,
            },
            {
                scaleX: 1,
                duration: 0.6,
                stagger: { each: 0.02, ease: 'power.out', from: 'random' },
                ease: 'power3.inOut',
            }, '<0.2');

        tl.call(() => this.text_lines.revert());
    }
}